<template>
  <el-dialog title="修改图片" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="beforeClose" append-to-body>
    <el-form>
      <el-form-item label="图片">
        <ul class="preview__ul">
          <li class="preview__li" v-for="(item, index) in images" :key="index">
            <el-tooltip class="item" effect="light" placement="top" :disabled="!detail.imgTagFlag && !detail.imgDefectiveTagFlag">
              <div slot="content">
                <div v-if="detail.imgTagFlag">
                  <el-checkbox v-model="item.outside" label="表面" border
                    @change="e => changeCheckbox(e, item, 'outside')"></el-checkbox>
                  <el-checkbox v-model="item.inside" label="内里" border
                    @change="e => changeCheckbox(e, item, 'inside')"></el-checkbox>
                </div>
                <div style="margin-top: 6px;" v-if="detail.imgDefectiveTagFlag">
                  <el-checkbox v-model="item.normal" label="正品" border
                    @change="e => changeCheckbox(e, item, 'normal')"></el-checkbox>
                  <el-checkbox v-model="item.defective" label="次品" border
                    @change="e => changeCheckbox(e, item, 'defective')"></el-checkbox>
                </div>
              </div>
              <el-image :src="item.imgUrl" :style="{ width: '100px', height: '100px' }" :preview-src-list="[item.imgUrl]"
                alt="图片" class="previewsImage-tag">
              </el-image>
            </el-tooltip>
            <div class="close-icon">
              <i class="el-icon-error" @click="delImg(item, index)"></i>
            </div>
          </li>
          <li @click="getImages">
            <el-upload class="uploader" :action="actionUrl" :on-change="uploadChange" :before-upload="beforeUpload"  accept="image/jpeg,image/jpg,image/png,"
              :data="uploadData" :http-request="uploadToOSS" :file-list="fileList" :show-file-list="false" :disabled="images.length > 4" v-show="images.length < 5">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="图移动端上传扫码">
        <canvas :id="canvasId" width="100" height="100" style="float:left"/>
        <el-button style="float:left" @click="getImages">获取图片</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" style="float:right;margin:0 10px;" @click="submit">确定</el-button>
        <el-button style="float:right" @click="beforeClose(()=>{dialogVisible = false})">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import QRCode from "qrcode";
import axios from "axios";
import { imgByCode, OSSsign, updateImgs,updatePurchaseImgs } from "@/apis/inHouse";
import ImgPreviews from "@/components/ImgPreviews";
export default {
  name: "Form",
  components:{ImgPreviews},
  data() {
    return {
      canvasId: Math.random().toFixed(8),
      dialogVisible: false,
      images: [],
      detail:{},
      actionUrl: "http://192.168.103.145/customer/oss/putOSS",
      fileList: [],
      uploadData: {},
    };
  },
  mounted() {},
  methods: {
    open(r) {
      this.dialogVisible = true;
      this.detail = r;
      this.getImages()
      
      this.$nextTick((_) => {
          let canvas = document.getElementById(this.canvasId);
          QRCode.toCanvas(canvas, r.picRelation, function (error) {
            if (error) console.error(error);
          });
        });
    },
    getImages: function () {
      imgByCode({ picRelation: this.detail.picRelation }).then(
        ({ code, data }) => {
          if (code === 0) {
            this.images = data.map(v => ({
              ...v,
              outside: v.tagList?.includes('outside'),
              inside: v.tagList?.includes('inside'),
              normal: v.tagList?.includes('normal'),
              defective: v.tagList?.includes('defective')
            }));
          }
        }
      );
    },
    beforeUpload(res) {
      console.log(res);
    },
    uploadChange(res) {
      console.log(res);
    },
    uploadToOSS(res) {
      if(this.images.length > 4){
        this.$message.warning('上传失败，图片数量大于5')
        return false
      }
      let name = String(Date.parse(new Date()) + res.file.name);
      let key = "transfer/" + name;
      let params = {
        path: ` /wms/abnormal/${this.$store.getters.getAuthInfo.userId}/fileUpload_${new Date().getTime()}.png`,
        type: 0,
        file:res.file
      }
      // uploadAliOSS(params).then(res=>{
      //   console.log(res)
      // })
      
      OSSsign({ path: "transfer/" }).then(({ code, data }) => {
        let forms = new FormData();
        forms.append("name", name);
        forms.append("key", key);
        forms.append("OSSAccessKeyId", data.accessId);
        forms.append("policy", data.policy);
        forms.append("signature", data.signature);
        forms.append("success_action_status", 200);
        forms.append("file", res.file);
        // imageToOss(data.host, forms);
        let host = data.host
        if(location.href.indexOf('https')>-1&&host.indexOf('https')===-1){
          host = host.replace('http','https')
        }
        axios({
          method: "post",
          url: host,
          data: forms,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((res) => {
          if (res.status == 200) {
            // this.saveImg(`${data.customDomain}/${key}`);
            this.images.push({
              imgUrl:`${data.customDomain}/${key}`,
              inside: false,
              outside: false,
              normal: false,
              defective: false
            })
            this.saveImg()
          }
        });
      });
    },
    delImg(item,index){
      let that = this
      let fn = function(){
        that.images.splice(index,1)
        that.saveImg()
      }
      this.beforeConfirm(fn)
    },
    saveImg() {
      let parmas = {
        picRelation: this.detail.picRelation,
        imgDTOList: this.images.map(item=>{
          const tagList = []
          const keys = ['outside', 'inside', 'normal', 'defective']
          keys.forEach((keyItem) => {
            if (item[keyItem]) {
              tagList.push(keyItem)
            }
          })
          return ({
          imgUrl: item.imgUrl,
          tagList: tagList
        })
        }),
        flowCode: this.detail.flowCode
      };
      updateImgs(parmas).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("修改成功");
          this.getImages()
        }else{
          this.getImages()
        }
      });
    },
    beforeConfirm(res,rej){
      imgByCode({ picRelation: this.detail.picRelation }).then(
        ({ code, data }) => {
          if (code === 0) {
            this.$emit('update')
            let check = data.some(item=>{return this.images.every((v)=>{ return item.imgUrl != v.imgUrl})})
            if(check || data.length != this.images.length){
              this.$message.warning('图片信息变更，请重新尝试')
              this.getImages()
              rej && rej()
            }else{
              res && res()
            }
          }
        }
      );
    },
    submit(){
      let params = {
        picRelation: this.detail.picRelation,
        imgDTOList: this.images.map(v => {
          const tagList = []
          const keys = ['outside', 'inside', 'normal', 'defective']
          keys.forEach((keyItem) => {
            if(v[keyItem]) {
              tagList.push(keyItem)
            }
          })
          return ({
            imgUrl: v.imgUrl,
            tagList: tagList
          })
        }),
        flowCode: this.detail.flowCode
      };
      let that = this
      let fn = function(){
        updatePurchaseImgs(params).then(({ code, data }) => {
          if (code === 0) {
            that.$message.success("修改成功");
            that.dialogVisible = false
          }
        });
      }
      this.beforeConfirm(fn)
    },
    beforeClose(done){
      this.beforeConfirm(done)
    },
    changeCheckbox(val, item, k) {
      if (val) {
        if (k === 'inside') {
          item.inside = true
          item.outside = false
        }
        if (k === 'outside') {
          item.inside = false
          item.outside = true
        }
        if (k === 'normal') {
          item.normal = true
          item.defective = false
        }
        if (k === 'defective') {
          item.normal = false
          item.defective = true
        }
      } else {
        item[k] = false
      }

      this.saveImg()
    },
  },
};
</script>
<style scoped>

.preview__ul {
  display: flex;
  /* grid-column-start: 1;
  grid-column-end: 5;
  grid-row-start: 2;
  grid-row-end: 3; */
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
  padding: 0 20px;
}

.preview__li {
  width: 100px;
  height: 100px;
  background: white;
  margin-right: 20px;
  position: relative;
}
.preview__li .close-icon{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #eee;
  position: absolute;
  top: -10px;
  right: -10px;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-textarea textarea {
  height: 120px;
}

.contentBox {
  display: flex;
  flex-direction: column;
}

.chenckBox {
  width: 120px;
}

.phoneBox {
  width: 240px;
}

.uploader {
  border: 1px solid #eee;
}

.uploader i {
  height: 100px;
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
